import React, { useState, useEffect } from "react";
import toast from "react-hot-toast";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import DataTable from "react-data-table-component";
import ItemService from "../../../services/customer_appCommonService";
import ItemServiceV1 from "../../../services/inventory_appCommonService";
import { useSelector, useDispatch } from "react-redux";
import Layout from "../../../Layout/Layout";
import { InputField } from "../../../Components/formElements/InputField";
import { ComboboxField } from "../../../Components/formElements/ComboboxField";
import { TextAreaField } from "../../../Components/formElements/TextAreaField";
import HeaderText from "../../../Components/Modal/supplier_app/PO_Collabration/HeaderText";
import SuccessRegisterModal from "../../../Components/SuccessRegisterModal";
import {
  getCurrentDate,
  isValidNumber,
  validateRequired,
} from "../../../common/Validations";
import FailureModal from "../../../Components/Modal/supplier_app/FailureModal";
import Loader from "../../../Components/Loader";
import { getPurchaseRequisition } from "../../../redux/feature/supplier_app/sourcingSlice";
import WarehouseConstants from "../../../common/WarehouseConstants";
import MaterialSelectionModalWH from "../Material/MaterialSelectionModalWH";
import { useNavigate } from "react-router-dom";

const CreateIndentWH = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  localStorage.setItem("menu", "Material");
  localStorage.setItem("submenu", "Material");
  let userData = useSelector((state) => state?.user);
  const [currentDate] = useState(getCurrentDate("default"));
  const [modalShow, setModalShow] = useState(false);
  // JSON Object
  const [formInputs, setFormInputs] = useState({
    module: "WAREHOUSE",
    manualIndicator: true,
    manualRelease: true,
    initiatorName: userData?.data?.firstName,
    initiator: userData?.data?.userId,
    userId: userData?.data?.userId,
    inquiryDocumentType: "IN",
    version: "V0",
    inqHeaderstatus: "New",
    salesDocumentGroup: "IN",
    // customerCode: userData?.data?.userId,
    customerCode: "",
    // customerName: userData?.data?.firstName,
    customerName: "",
    inquiryCategory: "",
    inquiryDocumentDate: currentDate,
    reqestDeliveryDate: "",
    salesOrg: "",
    salesGroup: "",
    companyCode: "",
    paymentTerms: "",
    incoTerms: "",
    incoTermsLocation: "",
    purchasingReqDocumentValue: "",
    inquiryRemark: "",
    headerTextData: [
      {
        itemIndex: "",
        documentId: "",
        documentText: "",
      },
    ],

    items: [
      {
        inquiryDocumentItemNr: "",
        itemTextData: [
          {
            itemIndex: "",
            documentId: "",
            documentText: "",
          },
        ],
        materialCode: "",
        inqItemStatus: "New",
        materialDescription: "",
        materialGroup: "",
        indentQty: "",
        orderUnitOfMeasure: "",
        orderPriceUnit: "",
        netValue: "",
        deliveryDate: "",
        itemCurrency: "",
        plant: "",
        storageLocn: "",
        taxCode: 0,
        taxAmount: 0,
      },
    ],
  });

  const modalData = {
    title: "PO Creation",
    successMsg: "",
  };

  const [getLoader, setLoader] = useState(true);

  // Inital Create PO
  // let POLineItemInitialCol = [
  //   {
  //     name: "Document Item Nr",
  //     selector: (row) => row.local_id || "--",
  //     sortable: true,
  //     width: "180px",
  //   },
  //   {
  //     name: "Item Text",
  //     selector: (row) => row.local_id || "--",
  //     sortable: true,
  //     width: "110px",
  //     cell: (row) => (
  //       <>
  //         <span
  //           style={{ marginLeft: "12px" }}
  //           onClick={() =>
  //             showLineItemHeaderText(row.local_id, row.itemTextData)
  //           }
  //         >
  //           <i className="bi bi-calendar2-week iconTable"></i>
  //         </span>
  //         <span className="suppliersIcon">
  //           {" "}
  //           {row.itemTextData?.length || 0}{" "}
  //         </span>
  //       </>
  //     ),
  //   },
  //   {
  //     name: "Material/Service ",
  //     selector: (row) => row.materialCode || "--",
  //     cell: (row) => (
  //       <InputField
  //         className="inputBox mt-1"
  //         // label="Please Enter the Remarks*"
  //         name="materialCode"
  //         placeholder=""
  //         value={row.materialCode || ""}
  //         onChange={(event) => handleInputChange(row.local_id, event)}
  //       />
  //     ),
  //     sortable: true,
  //     width: "200px",
  //   },
  //   {
  //     name: "Description",
  //     selector: (row) => row.materialDescription || "--",
  //     cell: (row) => (
  //       <TextAreaField
  //         className="inputBox mt-1"
  //         name="materialDescription"
  //         placeholder=""
  //         value={row.materialDescription || ""}
  //         onChange={(event) => handleInputChange(row.local_id, event)}
  //       />
  //     ),
  //     sortable: true,
  //     width: "200px",
  //   },
  //   {
  //     name: "Material Group ",
  //     selector: (row) => row.materialGroup || "--",
  //     cell: (row) => (
  //       <InputField
  //         className="inputBox mt-1"
  //         // label="Please Enter the Remarks*"
  //         name="materialGroup"
  //         placeholder=""
  //         value={row.materialGroup || ""}
  //         onChange={(event) => handleInputChange(row.local_id, event)}
  //       />
  //     ),
  //     sortable: true,
  //     width: "200px",
  //   },
  //   {
  //     name: "Quantity ",
  //     selector: (row) => row.indentQty || "--",
  //     cell: (row) => (
  //       <InputField
  //         className="inputBox mt-1"
  //         name="indentQty"
  //         placeholder=""
  //         value={row.indentQty || ""}
  //         onChange={(event) => handleInputChange(row.local_id, event, "Number")}
  //       />
  //     ),
  //     sortable: true,
  //     width: "200px",
  //   },
  //   {
  //     name: "UOM ",
  //     selector: (row) => row.orderUnitOfMeasure || "--",
  //     cell: (row) => (
  //       <InputField
  //         className="inputBox mt-1"
  //         name="orderUnitOfMeasure"
  //         placeholder=""
  //         value={row.orderUnitOfMeasure || ""}
  //         onChange={(event) => handleInputChange(row.local_id, event)}
  //       />
  //     ),
  //     width: "200px",
  //   },
  //   {
  //     name: "Delivery Date",
  //     selector: (row) => row.deliveryDate || "--",
  //     cell: (row) => (
  //       <InputField
  //         className="inputBox mt-1"
  //         type="date"
  //         name="deliveryDate"
  //         placeholder=""
  //         value={row.deliveryDate || ""}
  //         onChange={(event) => handleInputChange(row.local_id, event)}
  //       />
  //     ),
  //     width: "200px",
  //   },
  //   {
  //     name: "Plant",
  //     selector: (row) => row.plant || "--",
  //     cell: (row) => (
  //       <InputField
  //         className="inputBox mt-1"
  //         // label="Please Enter the Remarks*"
  //         name="plant"
  //         placeholder=""
  //         value={row.plant || ""}
  //         onChange={(event) => handleInputChange(row.local_id, event)}
  //       />
  //     ),
  //     sortable: true,
  //     width: "200px",
  //   },
  //   {
  //     name: "Storage Location",
  //     selector: (row) => row.storageLocn || "--",
  //     cell: (row) => (
  //       <InputField
  //         className="inputBox mt-1"
  //         // label="Please Enter the Remarks*"
  //         name="storageLocn"
  //         placeholder=""
  //         value={row.storageLocn || ""}
  //         onChange={(event) => handleInputChange(row.local_id, event)}
  //       />
  //     ),
  //     sortable: true,
  //     width: "200px",
  //   },
  //   {
  //     name: "Delete",
  //     selector: (row) => row.local_id || "--",
  //     sortable: true,
  //     cell: (row) => (
  //       <button
  //         className="btn btn-danger"
  //         onClick={() => removePOItemRow(row.local_id)}
  //       >
  //         <i className="bi bi-trash3"></i>
  //       </button>
  //     ),
  //     width: "120px",
  //   },
  // ];

  const addProductDetails = () => {
    setModalShow(true);
  };

   const handleDraft = async () => {
    let obj = {
      data: formInputs,
      type: "Draft",
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    };

    await ItemServiceV1.addMatIndent(obj).then((item) => {
      if (item?.status === 200) {
        toast.success(item?.message || "added successfully", {
          duration: 8000,
          position: "top-right",
        });
        navigate(WarehouseConstants.WH_MAT_INDENT_LIST);
      } else {
        toast.error(item?.message || "Please try again !!", {
          duration: 4000,
          position: "top-right",
        });
      }
      setDisabled(false);
    });
  };

  const handleSubmit = async (type) => {
    if (type === "Save") {
      await handleSave(type);
    } else if (type === "Draft") {
      await handleDraft(type);
    }
  };
  const handleGetSelectedMaterial = (selectedData) => {
    setPOLineItemsData((prevData) => {
      const updatedData = [
        ...prevData,
        ...selectedData.map((item, index) => ({
          ...item,
          orderUnitOfMeasure: item.unit || "",
          materialGroup: item.materialGroupDescription || "",
          local_id: index + 1,
        })),
      ];
      const uniqueData = Array.from(
        new Map(updatedData.map((item) => [item._id, item])).values(),
      );

      const sortedData = uniqueData
        .map((item, index) => ({
          ...item,
          local_id: index + 1, // Reset local_id sequentially
        }))
        .sort((a, b) => a.local_id - b.local_id);

      return sortedData;
    });
  };
  let POLineItemInitialCol = [
    {
      name: "Document Item Nr",
      selector: (row) => row.local_id || "--",
      sortable: true,
      width: "180px",
    },
    {
      name: "Item Text",
      selector: (row) => row.local_id || "--",
      sortable: true,
      width: "110px",
      cell: (row) => (
        <>
          <span
            style={{ marginLeft: "12px" }}
            // onClick={() => lineItemShowModal(row.itemTextData)}
          >
            <i className="bi bi-calendar2-week iconTable"></i>
          </span>
          <span className="suppliersIcon">
            {" "}
            {row.itemTextData?.length || 0}{" "}
          </span>
        </>
      ),
    },
    {
      name: "Material/Service ",
      selector: (row) => row.materialCode || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          // label="Please Enter the Remarks*"
          name="materialCode"
          placeholder=""
          value={row.materialCode || ""}
          onChange={(event) => handleInputChange(row.local_id, event)}
          disabled={true}
        />
      ),
      sortable: true,
      width: "200px",
    },
    // Add this column to your PRLineItemInitialCol array
    {
      name: "Description",
      selector: (row) => row.materialDescription || "--",
      cell: (row) => (
        <TextAreaField
          className="inputBox mt-1"
          name="materialDescription"
          placeholder=""
          value={row.materialDescription || ""}
          onChange={(event) => handleInputChange(row.local_id, event)}
          disabled={true}
        />
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "Material Group ",
      selector: (row) => row.materialGroupDescription || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          // label="Please Enter the Remarks*"
          name="materialGroupDescription"
          placeholder=""
          value={row.materialGroupDescription || ""}
          onChange={(event) => handleInputChange(row.local_id, event)}
          disabled={true}
        />
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "Material Category",
      selector: (row) => row.venderMaterialSubCategory || "--",
      cell: (row) => (
        <select
          className="form-select inputBox mt-1"
          name="materialSubCatagory"
          value={row.venderMaterialSubCategory || ""}
          onChange={(event) => handleInputChange(row.local_id, event)}
          style={{ minWidth: "200px" }}
        >
          <option value="">Select Sub Category</option>
          {row.materialSubCatagory?.map((subCat, index) => (
            <option key={index} value={subCat.matSubCatagoryCode}>
              {subCat.matSubCatagoryDesc} ({subCat.matSubCatagoryCode})
            </option>
          ))}
        </select>
      ),
      sortable: true,
      width: "250px",
    },
    {
      name: "Quantity ",
      selector: (row) => row.purchaseQuantity || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          type="number"
          min="0"
          name="purchaseQuantity"
          value={row.purchaseQuantity ?? ""}
          onChange={(e) => handleInputChange(row.local_id, e, "Number")}
        />
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "UOM ",
      selector: (row) => row.unit || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="unit"
          placeholder=""
          value={row.unit || ""}
          onChange={(event) => handleInputChange(row.local_id, event)}
          disabled={true}
        />
      ),
      width: "200px",
    },
    {
      name: "Currency ",
      selector: (row) => row.currencyCode || "INR",
      width: "120px",
    },
    {
      name: "Delivery Date",
      selector: (row) => row.deliveryDate || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          type="date"
          name="deliveryDate"
          placeholder=""
          value={row.deliveryDate || ""}
          onChange={(event) => handleInputChange(row.local_id, event)}
        />
      ),
      width: "200px",
    },
    {
      name: "Delete",
      selector: (row) => row.local_id || "--",
      sortable: true,
      cell: (row) => (
        <button
          className="btn btn-danger"
          onClick={() => removePOItemRow(row.local_id)}
        >
          <i className="bi bi-trash3"></i>
        </button>
      ),
      width: "120px",
    },
  ];
  let PRLineItemInitialCol = [
    {
      name: (
        <>
          <i className="bi bi-hash labelIcon"></i>
          Document Item Nr
        </>
      ),
      selector: (row) => row.local_id || "--",
      sortable: true,
      width: "200px",
    },
    {
      name: (
        <>
          <i className="bi bi-card-text labelIcon"></i>
          Item Text
        </>
      ),
      selector: (row) => row.local_id || "--",
      sortable: true,
      width: "150px",
      cell: (row) => (
        <>
          <span
            style={{ marginLeft: "12px" }}
            onClick={() =>
              showLineItemHeaderText(row.local_id, row.itemTextData)
            }
          >
            <i className="bi bi-card-text iconTable"></i>
          </span>
          <span className="suppliersIcon">{row.itemTextData?.length || 0}</span>
        </>
      ),
    },
    {
      name: (
        <>
          <i className="bi bi-box-seam labelIcon"></i>
          Material/Service
        </>
      ),
      selector: (row) => row.materialCode || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="materialCode"
          placeholder=""
          value={row.materialCode || ""}
          onChange={(event) => handleInputChange(row.local_id, event)}
        />
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: (
        <>
          <i className="bi bi-file-earmark-text labelIcon"></i>
          Description
        </>
      ),
      selector: (row) => row.materialDescription || "--",
      cell: (row) => (
        <TextAreaField
          className="inputBox mt-1"
          name="materialDescription"
          placeholder=""
          value={row.materialDescription || ""}
          onChange={(event) => handleInputChange(row.local_id, event)}
        />
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: (
        <>
          <i className="bi bi-collection labelIcon"></i>
          Material Group
        </>
      ),
      selector: (row) => row.materialGroup || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="materialGroup"
          placeholder=""
          value={row.materialGroup || ""}
          onChange={(event) => handleInputChange(row.local_id, event)}
        />
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: (
        <>
          <i className="bi bi-123 labelIcon"></i>
          Quantity
        </>
      ),
      selector: (row) => row.indentQty || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="indentQty"
          placeholder=""
          value={row.indentQty || ""}
          onChange={(event) => handleInputChange(row.local_id, event, "Number")}
        />
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: (
        <>
          <i className="bi bi-rulers labelIcon"></i>
          UOM
        </>
      ),
      selector: (row) => row.orderUnitOfMeasure || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="orderUnitOfMeasure"
          placeholder=""
          value={row.orderUnitOfMeasure || ""}
          onChange={(event) => handleInputChange(row.local_id, event)}
        />
      ),
      width: "200px",
    },
    {
      name: (
        <>
          <i className="bi bi-calendar-check labelIcon"></i>
          Delivery Date
        </>
      ),
      selector: (row) => row.deliveryDate || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          type="date"
          name="deliveryDate"
          placeholder=""
          value={row.deliveryDate || ""}
          onChange={(event) => handleInputChange(row.local_id, event)}
        />
      ),
      width: "200px",
    },
    {
      name: (
        <>
          <i className="bi bi-building labelIcon"></i>
          Plant
        </>
      ),
      selector: (row) => row.plant || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="plant"
          placeholder=""
          value={row.plant || ""}
          onChange={(event) => handleInputChange(row.local_id, event)}
        />
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: (
        <>
          <i className="bi bi-geo-alt labelIcon"></i>
          Storage Location
        </>
      ),
      selector: (row) => row.storageLocn || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="storageLocn"
          placeholder=""
          value={row.storageLocn || ""}
          onChange={(event) => handleInputChange(row.local_id, event)}
        />
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: (
        <>
          <i className="bi bi-trash3 labelIcon"></i>
          Delete
        </>
      ),
      selector: (row) => row.local_id || "--",
      sortable: true,
      cell: (row) => (
        <button
          className="btn btn-danger"
          onClick={() => removePOItemRow(row.local_id)}
        >
          <i className="bi bi-trash3"></i>
        </button>
      ),
      width: "120px",
    },
  ];
  let POLineItemInitialData = [
    {
      local_id: 1,
      inquiryDocumentItemNr: 1,
      itemTextData: [],
      inqItemStatus: "In Release",

      taxCode: 0,
      taxAmount: 0,
    },
  ];

  const [isCardVisible, setCardVisible] = useState(true);
  const [isCardVisible4, setCardVisible4] = useState(true);

  // eslint-disable-next-line no-unused-vars
  const [getDisabledStatus, setDisabledStatus] = useState(false);
  const [getDropdownData, setDropdownData] = useState("");

  // const [loading, setLoading] = useState(false);
  const [getLineItemHeaderTextModal, setLineItemHeaderTextModal] =
    useState(false);
  const [getHeaderTextIndex, setHeaderTextIndex] = useState(0);
  const [getDataToHeaderText, setDataToHeaderText] = useState([]);
  const [subTotalValue, setSubTotalValue] = useState(0);
  const [getTaxAmountValue, setTaxAmountValue] = useState(0);
  const [getItemAmountValue, setItemAmountValue] = useState(0);
  const [getPurchaseType, setPurchaseType] = useState(0);
  const [getPurchaseCategory, setPurchaseCategory] = useState(0);
  // eslint-disable-next-line
  const [getpurchaseGroup, setpurchaseGroup] = useState(0);

  // Header Text
  const handleHeaderTextLineItemData = (data) => {
    setPOLineItemsData((prevUsers) =>
      prevUsers.map((item) =>
        item.inquiryDocumentItemNr === getHeaderTextIndex
          ? { ...item, itemTextData: data }
          : item,
      ),
    );
  };

  /* pop failure modal */
  const failureModalData = {
    title: "Warning",
    ErrorMsg: "",
  };

  const [disabled, setDisabled] = useState(false);
  const [getShowSuccessModal, setShowSuccessModal] = useState(false);
  const [getModalInfo, setModalInfo] = useState(modalData);
  const [getPOLineItemsData, setPOLineItemsData] = useState(
    POLineItemInitialData,
  );
  // eslint-disable-next-line no-unused-vars
  const [getPOLineItemsCol, setPOLineItemsCol] = useState(POLineItemInitialCol);

  const [getPurchaseOrg, setPurchaseOrg] = useState([]);
  const [getCompanyCode, setCompanyCode] = useState([]);
  // const [getINCOTerms, setINCOTerms] = useState([]);
  const [getpaymentTerm, setpaymentTerm] = useState([]);

  // eslint-disable-next-line no-unused-vars
  const [getFailureModal, setFailureModal] = useState(failureModalData);
  const [getShowFailureModal, setShowFailureModal] = useState(false);
  const [getErrorFields, setErrorFields] = useState([]);

  const hideFailureModal = () => {
    setShowFailureModal(false);
  };

  const hideModal = () => {
    setModalShow(false);
  };

  /* Show Success Modal */
  const onSuccessfullyRegistered = () => {
    setShowSuccessModal(true);
  };
  const hideSuccessModal = () => {
    setShowSuccessModal(false);
  };

  const toggleCardVisibility = () => {
    setCardVisible(!isCardVisible);
  };
  const toggleCardVisibility4 = () => {
    setCardVisible4(!isCardVisible4);
  };

  /* Create PO Line Item Header Text Modal Function */
  const showLineItemHeaderText = (index, data) => {
    setLineItemHeaderTextModal(true);
    setHeaderTextIndex(index);
    setDataToHeaderText(data);
  };
  const hideLineItemHeaderText = () => {
    setLineItemHeaderTextModal(false);
  };

  const onInputChange = ({ target: { name, value } }) => {
    setFormInputs((formInputs) => ({ ...formInputs, [name]: value }));
    // console.log("onInputChange => formInputs", formInputs);
  };

  // Get Dropdown data select
  useEffect(() => {
    // console.log(">> Dropdown data > ", getDropdownData);
    if (getDropdownData?.code === "MAT") {
      // Material
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.code,
      }));
      // setPOLineItemsCol(POLineItemInitialCol);
      // setPOLineItemsData(POLineItemInitialData);
    } else {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.code,
      }));
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getDropdownData]);

  const handleInputChange = (local_id, event, type, vat) => {
    const { name, value } = event.target;
    if (type === "Number" && vat === undefined) {
      if (isValidNumber(value)) {
        setPOLineItemsData((prevRows) =>
          prevRows.map((row) => {
            return row.local_id === local_id
              ? {
                  ...row,
                  [name]: value,
                  netValue:
                    name === "indentQty"
                      ? row.orderPriceUnit * value
                      : row.indentQty * value,
                  taxAmount:
                    (Number(row.taxCode) / 100) *
                    (name === "indentQty"
                      ? row.orderPriceUnit * value
                      : row.indentQty * value),
                }
              : row;
          }),
        );
      }
    } else if (type === "Number" && vat === "VAT") {
      if (isValidNumber(value)) {
        setPOLineItemsData((prevRows) =>
          prevRows.map((row) =>
            row.local_id === local_id
              ? {
                  ...row,
                  [name]: value,
                  taxAmount:
                    name === "taxCode"
                      ? (Number(value) / 100) *
                        (Number(row.indentQty || 0) *
                          Number(row.orderPriceUnit || 0))
                      : 0,
                }
              : row,
          ),
        );
      }
    } else {
      setPOLineItemsData((prevRows) =>
        prevRows.map((row) =>
          row.local_id === local_id ? { ...row, [name]: value } : row,
        ),
      );
    }
    // getTotalCount()
  };

  // Get Total for SubTotal Pricing Schedule
  useEffect(() => {
    // console.log(">> getPOLineItemsData", getPOLineItemsData);

    const getItemTotal = getPOLineItemsData?.reduce(
      (accumulator, currentValue) =>
        accumulator + (currentValue?.netValue || 0),
      0,
    );
    const taxTotalAmount = getPOLineItemsData?.reduce(
      (accumulator, currentValue) =>
        accumulator + (currentValue?.taxAmount || 0),
      0,
    );

    setTaxAmountValue(taxTotalAmount);
    setItemAmountValue(getItemTotal);

    setSubTotalValue(getItemTotal + taxTotalAmount);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getPOLineItemsData]);

  useEffect(() => {
    getMasterDataFunc();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //Load Master Data
  const getMasterDataFunc = async () => {
    // 1
    // let obj1 = {};
    // await ItemService.getSupplierDatail(obj1).then((item) => {

    //   if (item?.status === 200) {
    //     setVendorDropdownData(item?.data);
    //   } else {
    //     setVendorDropdownData([]);
    //     console.log(">> Error: Loading getSupplierDatail");
    //   }
    // });

    // 2
    let obj2 = {
      codeType: "purchaseOrganisation",
    };
    await ItemService.getMasterData(obj2).then((item) => {
      // console.log('>> Check title ',item);
      if (item?.status === 200) {
        setPurchaseOrg(item?.data);
      } else {
        setPurchaseOrg([]);
        console.log(">> Error: Loading getMasterData");
      }
    });
    let obj3 = {
      codeType: "companyCode",
    };
    await ItemService.getMasterData(obj3).then((item) => {
      // console.log('>> Check title ',item);
      if (item?.status === 200) {
        setCompanyCode(item?.data);
      } else {
        setCompanyCode([]);
        console.log(">> Error: Loading getMasterData");
      }
    });
    let obj6 = {
      codeType: "paymentTerm",
    };
    await ItemService.getMasterData(obj6).then((item) => {
      // console.log('>> Check title ',item);
      if (item?.status === 200) {
        setpaymentTerm(item?.data);
      } else {
        setpaymentTerm([]);
        console.log(">> Error: Loading getMasterData");
      }
    });

    let obj12 = {
      codeType: "PrPurchaseType",
    };
    await ItemService.getMasterData(obj12).then((item) => {
      if (item?.status === 200) {
        setPurchaseType(item?.data);
      } else {
        setPurchaseType([]);
        console.log(">> Error: Loading getMasterData");
      }
    });
    let obj13 = {
      codeType: "PurchaseCategory",
    };
    await ItemService.getMasterData(obj13).then((item) => {
      if (item?.status === 200) {
        setPurchaseCategory(item?.data);
      } else {
        setPurchaseCategory([]);
        console.log(">> Error: Loading getMasterData");
      }
    });
    let obj14 = {
      codeType: "paymentTerm",
    };
    await ItemService.getMasterData(obj14).then((item) => {
      if (item?.status === 200) {
        setpurchaseGroup(item?.data);
      } else {
        setpurchaseGroup([]);
        console.log(">> Error: Loading getMasterData");
      }
    });

    setLoader(false);
  };

  // SAVE
  const handleSave = async () => {
    let requiredFields = [];

    if (!validateRequired(formInputs.paymentTerms)) {
      requiredFields.push("*Please Select the Payment Terms");
      setErrorFields(requiredFields);
      setShowFailureModal(true);
      return;
    }
    if (!validateRequired(formInputs.salesType)) {
      requiredFields.push("*Please Select the Purchase Type");
      setErrorFields(requiredFields);
      setShowFailureModal(true);
      return;
    }

    if (
      typeof getPOLineItemsData[0]?.materialCode === "undefined" ||
      typeof getPOLineItemsData[0]?.indentQty === "undefined" ||
      typeof getPOLineItemsData[0]?.orderUnitOfMeasure === "undefined" ||
      // typeof getPOLineItemsData[0]?.orderPriceUnit === "undefined" ||
      typeof getPOLineItemsData[0]?.deliveryDate === "undefined"
    ) {
      requiredFields.push("*Alteast one PO Line item should be added.");
      setErrorFields(requiredFields);
      setShowFailureModal(true);
      return;
    }

    // let lineItem = []
    formInputs.items = getPOLineItemsData;
    formInputs.purchasingReqDocumentValue = subTotalValue;
    formInputs.purchasingDocumentTaxTotalValue = getTaxAmountValue;
    formInputs.purchasingDocumentItemTotalValue = getItemAmountValue;

    // console.log(">> handleSave", formInputs);

    const toastId = toast.loading("Loading...", {
      position: "top-right",
    });

    let obj = {
      data: formInputs,
      type:"Save"
    };

    setDisabled(true);
    await ItemServiceV1.addMatIndent(obj).then((item) => {
      // console.log(">> res!", item);
      if (item?.status === 200) {
        modalData.successMsg = item?.message;
        setModalInfo(modalData);
        onSuccessfullyRegistered();

        dispatch(getPurchaseRequisition({}));
      } else {
        toast.error(item?.message || "Please try again !!", {
          duration: 4000,
          position: "top-right",
        });
      }
    });
    toast.dismiss(toastId);
    setDisabled(false);
  };

  const removePOItemRow = (local_id) => {
    setPOLineItemsData((prevPrograms) =>
      prevPrograms.filter((program) => program.local_id !== local_id),
    );
  };

  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide quoation">
          <div className="rightSideInner PageCommonCSS">
            <h2 className="mainTitle">Create Indent</h2>
            <p className="subText">Fill Create Indent Details</p>
            <hr />

            <Loader isLoading={getLoader} className={"text-center"} />

            {!getLoader && (
              <>
                {/*Document Header Details */}
                <div className="accordion mb-4" id="accordionExample">
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <Row className="accordion-button">
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-left arrowBtn"
                        >
                          <i
                            className={`bi ${
                              isCardVisible
                                ? "bi-chevron-right"
                                : "bi-chevron-down"
                            }`}
                            onClick={toggleCardVisibility}
                          ></i>
                        </Col>
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-center logoBtn"
                        >
                          <span className="iconLogo">HD</span>
                        </Col>
                        <Col xs={12} md={9} lg={9}>
                          <span className="headerTitle">Header Details</span>
                          <span className="subHeaderTitle">
                            Document Description and Details{" "}
                          </span>
                        </Col>

                        {/* <Col xs={2} md={1} lg={1} className="">
                      <POCollabrationCommonFillter />
                    </Col> */}
                      </Row>
                    </h2>
                    <div
                      className={`accordion-collapse collapse show ${
                        isCardVisible ? "visible" : ""
                      }`}
                    >
                      <div className="accordion-body">
                        <Row className="pt-2 pb-4">
                          {/* <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              id="indentDocumentType"
                              className="inputBox"
                              // label="Document type"
                              label={
                                <>
                                  <i className="bi bi-file-earmark-text labelIcon"></i>
                                  Document Type
                                </>
                              }
                              name="indentDocumentType"
                              placeholder=""
                              value={formInputs.indentDocumentType}
                              onChange={onInputChange}
                              disabled={true}
                            />
                          </Col> */}
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              id="indentDocumentDate"
                              className="inputBox"
                              // label="Document Date"
                              label={
                                <>
                                  <i className="bi bi-calendar-date labelIcon"></i>
                                  Document Date
                                </>
                              }
                              name="indentDocumentDate"
                              placeholder=""
                              type="date"
                              value={formInputs.indentDocumentDate}
                              onChange={onInputChange}
                              disabled={getDisabledStatus}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              id="indentHeaderstatus"
                              className="inputBox"
                              // label="Status"
                              label={
                                <>
                                  <i className="bi bi-check-circle labelIcon"></i>
                                  Status
                                </>
                              }
                              name="indentHeaderstatus"
                              placeholder=""
                              value={formInputs.indentHeaderstatus}
                              onChange={onInputChange}
                              disabled={true}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              id="version"
                              className="inputBox"
                              // label="Version"
                              label={
                                <>
                                  <i className="bi bi-code-slash labelIcon"></i>
                                  Version
                                </>
                              }
                              name="version"
                              placeholder=""
                              value={formInputs.version}
                              onChange={onInputChange}
                              disabled={true}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <ComboboxField
                              id="salesType"
                              // label="Order Type"
                              label={
                                <>
                                  <i className="bi bi-cart-check labelIcon"></i>
                                  Order Type
                                </>
                              }
                              placeholder=""
                              data={getPurchaseType}
                              iconClassName="dropdownIcon"
                              name="salesType"
                              code="salesTypeCode"
                              setValue={formInputs?.salesType || []}
                              getvalue={setDropdownData}
                              disabled={false}
                              required={true}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <ComboboxField
                              id="salesCategory"
                              // label="Order Category"
                              label={
                                <>
                                  <i className="bi bi-diagram-3 labelIcon"></i>
                                  Order Category
                                </>
                              }
                              placeholder=""
                              data={getPurchaseCategory}
                              iconClassName="dropdownIcon"
                              name="salesCategory"
                              code="salesCategoryCode"
                              setValue={formInputs?.salesCategory || []}
                              getvalue={setDropdownData}
                              disabled={false}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              id="customerCode"
                              className="inputBox"
                              // label="Customer Code"
                              label={
                                <>
                                  <i className="bi bi-person-badge labelIcon"></i>
                                  Customer Code
                                </>
                              }
                              name="customerCode"
                              placeholder=""
                              value={formInputs.customerCode}
                              onChange={onInputChange}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              id="customerName"
                              className="inputBox"
                              // label="Customer Name"
                              label={
                                <>
                                  <i className="bi bi-person labelIcon"></i>
                                  Customer Name
                                </>
                              }
                              name="customerName"
                              placeholder=""
                              value={formInputs.customerName}
                              onChange={onInputChange}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <ComboboxField
                              // label="Company Code"
                              label={
                                <>
                                  <i className="bi bi-building labelIcon"></i>
                                  Company Code
                                </>
                              }
                              extraLabel="SAP Company Code"
                              placeholder=""
                              data={getCompanyCode}
                              id="companyCode"
                              iconClassName="dropdownIcon"
                              name="companyCode"
                              code="companyCodeCode"
                              setValue={formInputs?.companyCode || []}
                              getvalue={setDropdownData}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <ComboboxField
                              // label="Sales Organization"
                              label={
                                <>
                                  <i className="bi bi-shop labelIcon"></i>
                                  Sales Organization
                                </>
                              }
                              extraLabel="SAP Purchase organization"
                              placeholder=""
                              data={getPurchaseOrg}
                              id="salesOrg"
                              iconClassName="dropdownIcon"
                              name="salesOrg"
                              code="salesOrgCode"
                              setValue={formInputs?.salesOrg || []}
                              getvalue={setDropdownData}
                            />
                          </Col>{" "}
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              // label="Distribution Channel"
                              label={
                                <>
                                  <i className="bi bi-diagram-2 labelIcon"></i>
                                  Distribution Channel
                                </>
                              }
                              name="disrtibutionChannel"
                              placeholder=""
                              value={formInputs.disrtibutionChannel || ""}
                              onChange={onInputChange}
                              disabled={getDisabledStatus}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              // label="Division"
                              label={
                                <>
                                  <i className="bi bi-grid-3x3-gap labelIcon"></i>
                                  Division
                                </>
                              }
                              name="division"
                              placeholder=""
                              value={formInputs.division || ""}
                              onChange={onInputChange}
                              disabled={getDisabledStatus}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <ComboboxField
                              // label="Payment Terms"
                              label={
                                <>
                                  <i className="bi bi-credit-card labelIcon"></i>
                                  Payment Terms
                                </>
                              }
                              extraLabel=""
                              placeholder=""
                              data={getpaymentTerm}
                              id="paymentTerms"
                              iconClassName="dropdownIcon"
                              name="paymentTerms"
                              code="paymentTermsCode"
                              setValue={formInputs?.paymentTerms || []}
                              getvalue={setDropdownData}
                              required={true}
                            />
                          </Col>
                          {/* <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <ComboboxField
                              label="INCOTerms"
                              extraLabel="INCOTerms Code"
                              placeholder=""
                              data={getINCOTerms}
                              id="incoTerms"
                              iconClassName="dropdownIcon"
                              name="incoTerms"
                              code="incoTermsCode"
                              setValue={formInputs?.incoTerms || []}
                              getvalue={setDropdownData}
                            />
                          </Col>

                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              id="incoTermsLocation"
                              className="inputBox"
                              label="INCOTerms Location"
                              name="incoTermsLocation"
                              placeholder=""
                              value={formInputs.incoTermsLocation}
                              onChange={onInputChange}
                            />
                          </Col> */}
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              id="reqestDeliveryDate"
                              className="inputBox"
                              // label="Request Delivery Date"
                              label={
                                <>
                                  <i className="bi bi-calendar-check labelIcon"></i>
                                  Request Delivery Date
                                </>
                              }
                              name="reqestDeliveryDate"
                              placeholder=""
                              type="date"
                              value={formInputs.reqestDeliveryDate}
                              onChange={onInputChange}
                              disabled={getDisabledStatus}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <TextAreaField
                              id="indentRemarks"
                              className="inputBox"
                              // label="Indent Remarks"
                              label={
                                <>
                                  <i className="bi bi-chat-left-text labelIcon"></i>
                                  Indent Remarks
                                </>
                              }
                              name="indentRemarks"
                              placeholder=""
                              value={formInputs.indentRemarks || ""}
                              onChange={onInputChange}
                            />
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="accordion mb-4" id="accordionExample">
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <Row className="accordion-button">
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-left arrowBtn"
                        >
                          <i
                            className={`bi ${
                              isCardVisible4
                                ? "bi-chevron-right"
                                : "bi-chevron-down"
                            }`}
                            onClick={toggleCardVisibility4}
                          ></i>
                        </Col>
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-center logoBtn"
                        >
                          <span className="iconLogo">LI</span>
                        </Col>
                        <Col xs={8} md={4} lg={4}>
                          <span className="headerTitle">Line Items</span>
                          <span className="subHeaderTitle">
                            Material/ Service Details
                          </span>
                        </Col>

                        <Col
                          xs={12}
                          md={6}
                          lg={6}
                          className="headerButtonAlign"
                        >
                          <Col xs={4} md={2} lg={2} className="">
                            <button
                              className="btnTable"
                              onClick={addProductDetails}
                            >
                              Add Material
                            </button>
                          </Col>
                        </Col>
                        {/* <Col xs={2} md={1} lg={1} className="">
                                     <SourcingCommonFilter />
                                   </Col> */}
                      </Row>
                    </h2>
                    <div
                      // id="acc"
                      className={`accordion-collapse collapse show ${
                        isCardVisible4 ? "visible" : ""
                      }`}
                      // aria-labelledby="headingOne"
                      // data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                        <Row>
                          <Col xs={12} md={12} lg={12}>
                            <DataTable
                              // title=""
                              columns={PRLineItemInitialCol}
                              // data={
                              //   formInputs?.rfqCreation === "PR"
                              //     ? getLineItemData
                              //     : getPRLineItemsData
                              // }

                              // columns={lineItemsColumns}
                              data={getPOLineItemsData}
                              // progressPending={loading}
                              // paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
                              // pagination
                              // paginationServer
                              // paginationTotalRows={totalRows}
                              // onChangeRowsPerPage={handlePerRowsChange}
                              // onChangePage={handlePageChange}
                              selectableRows
                            />
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
        </Col>
      </Row>
      {!getLoader && (
        <>
          <Row className="mb-4">
            <Col className="d-flex justify-content-end btnActionGroup" >
              <button
                type="button"
                className="btnTable btnAction"
                onClick={() => handleSubmit("Save")}
                disabled={disabled}
              >
                <i className="bi bi-save"></i> Create
              </button>

              <button
                type="button"
                className="btnTable btnAction"
                onClick={() => handleSubmit("Draft")}
                disabled={disabled}
              >
                <i className="bi bi-file-earmark"></i> Draft
              </button>
            </Col>
          </Row>
        </>
      )}

      {/* Price Shedule / Line Item */}
      <HeaderText
        index={getHeaderTextIndex}
        headername="Header Text for Line Item"
        show={getLineItemHeaderTextModal}
        onHide={hideLineItemHeaderText}
        hedertextdata={handleHeaderTextLineItemData}
        showcurrentdata={getDataToHeaderText}
        masterdata="POItemTextID"
      />

      <SuccessRegisterModal
        show={getShowSuccessModal}
        onHide={() => hideSuccessModal()}
        modaldata={getModalInfo}
        aftersuccess={WarehouseConstants.WH_MAT_INDENT_LIST}
      />

      <FailureModal
        show={getShowFailureModal}
        onHide={() => hideFailureModal()}
        failuremodaldata={getFailureModal}
        requiredfields={getErrorFields}
      />
      <MaterialSelectionModalWH
        show={modalShow}
        onHide={() => hideModal()}
        onselectedcatdata={handleGetSelectedMaterial}
      />
    </main>
  );
};

export default CreateIndentWH;
